module.exports = __webpack_public_path__ + "img/info-3.f5407562.svg";